import { createFileRoute } from '@tanstack/react-router';

import { AddKeywords } from 'features/get-started/AddKeywords';

export const Route = createFileRoute('/_authenticated/get-started/_get-started/add-keywords/')({
  component: AddKeywordsRoute
});

function AddKeywordsRoute() {
  return <AddKeywords />;
}
